export default __webpack_public_path__ + "d2ca3dcfe0c4a46226870ed5549e086a.png";